<script setup lang="ts">
import type { Item } from './Item.vue'

defineOptions({
  name: 'ContentBlockAdditionalSlot',
})

interface Props {
  items: Item[]
}

const props = defineProps<Props>()
const hasItems = computed<boolean>(() => props.items?.length > 0)
</script>

<template>
  <div
    v-if="hasItems"
    class="additional-slot"
  >
    <ContentBlockAdditionalSlotItem
      v-for="(item, index) in items"
      :key="`additional-slot-item-${index}`"
      v-bind="item"
      class="additional-slot__item"
    />
  </div>
</template>

<style scoped lang="scss">
.additional-slot {
  @apply mr-[10px] flex items-center gap-[10px];
  @apply xl:gap-[40px];
}
</style>
